import {
  Button,
  DateInput,
  TextInput,
  required,
  useDataProvider,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "react-admin";
import PauseIcon from "@mui/icons-material/Pause";
import DoneIcon from "@mui/icons-material/Done";
import FormModal from "server/components/Modals/FormModal";

const InterruptButton = () => {
  const { selectedIds, resource } = useListContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll(resource);

  // No try/catch: FormModal notifies on error and stays open.
  const interruptStudies = async data => {
    await dataProvider.create(`${resource}/interrupt`, { data: { educationSemesterIds: selectedIds, ...data } });
    notify("Успешно прекъснато обучение на избраните студенти", { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <FormModal
      triggerButton={
        <Button label="Прекъсни">
          <PauseIcon />
        </Button>
      }
      titleContent="Прекъсване на обучение"
      onConfirm={interruptStudies}
      saveTitle="Прекъсни"
      saveIcon={<DoneIcon />}
      closeTitle="Затвори"
      dialogSize="xs"
    >
      <DateInput
        source="orderDate"
        label="Дата на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
      <TextInput
        source="orderNumber"
        label="Номер на заповед"
        validate={required()}
        helperText={false}
        fullWidth
      />
    </FormModal>
  );
};

export default InterruptButton;
